export default ({ request }) => ({
  //物料公共组件树形下拉api
  materialCategoryListTreeApi(data = {}) {
    return request({
      url: '/master/material/category/select/material/list/tree',
      method: 'post',
      data,
    })
  },
})
